<template>
  <div class="context-menu dropdown" :id="id">
    <div
      class="context-menu-toggle dropdown-toggle"
      :id="`${id}-toggle`"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <slot>
        <span class="icon-arrow-down"></span>
      </slot>
    </div>

    <div
      class="dropdown-menu"
      :class="`dropdown-menu-${align}`"
      :aria-labelledby="`${id}-toggle`"
    >
      <div class="dropdown-menu-inner">
        <slot name="menu-before"></slot>
        <div
          v-for="(item, i) in items"
          :key="i"
          class="dropdown-item"
          :class="item.class"
          @click.prevent="itemClick(item)"
        >
          <span v-html="item.label"></span>
          <span v-if="!!item.sublabel" v-html="item.sublabel"></span>
        </div>
        <slot name="menu-after"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: { type: String, required: true },
    items: { type: Array, required: true },
    align: { type: String, default: "center" },
  },
  methods: {
    hide() {
      this.$emit("hide");
      $(`#${this.id}`).dropdown("hide");
    },
    itemClick(item) {
      if (item.action) {
        item.action();
      }
    },
  },
};
</script>
